import { getCdutcmPortalConfig, getOnlinePaymentConfig, getOrgConfig } from "@/api/config";

const state = () => ({
    orgConfig: {},
    onlinePaymentConfig: {},
    cdutcmPortalConfig: {}
});

const getters = {
    orgConfig: state => {
        return state.orgConfig;
    },
    onlinePaymentConfig: state => {
        return state.onlinePaymentConfig;
    },
    cdutcmPortalConfig: state => {
        return state.cdutcmPortalConfig;
    }
};

const actions = {
    getOrgConfig: async ({ commit }) => {
        const res = await getOrgConfig();
        const orgConfig = res.data.data;
        commit("orgConfig", orgConfig);
    },
    getOnlinePaymentConfig: async ({ commit }) => {
        const res = await getOnlinePaymentConfig();
        const onlinePaymentConfig = res.data.data;
        commit("onlinePaymentConfig", onlinePaymentConfig);
    },
    getCdutcmPortalConfig: async ({ commit }) => {
        const res = await getCdutcmPortalConfig();
        const cdutcmPortalConfig = res.data.data;
        commit("cdutcmPortalConfig", cdutcmPortalConfig);
    }
};

const mutations = {
    orgConfig: (state, orgConfig) => {
        state.orgConfig = orgConfig;
    },
    onlinePaymentConfig: (state, onlinePaymentConfig) => {
        state.onlinePaymentConfig = onlinePaymentConfig;
    },
    cdutcmPortalConfig: (state, cdutcmPortalConfig) => {
        state.cdutcmPortalConfig = cdutcmPortalConfig;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
